import { useEffect, useState } from 'react';
import styles from './ConsumerDetails.module.scss';
// import { ConsumerDevices } from './ConsumerDevices/ConsumerDevices';
import { useParams } from 'react-router-dom';
import { Card, CardHeader, CardContent } from '@mui/material';
import { ConsumerInfo } from './ConsumerInfo/ConsumerInfo';
import { getUser } from 'lib/firebase';
import { FirebaseUser } from 'types/User/firebaseTypes';

export const ConsumerDetails = () => {
    const params = useParams();
    const [user, setUser] = useState<FirebaseUser>();

    // Look up the user by the id in the URL.
    useEffect(() => {
        if (params.id) {
            getUser(params.id).then((user: FirebaseUser | null) => {
                if (user) setUser(user);
            });
        }
    }, [params.id]);

    return (
        <div data-testid="ConsumerDetails" className={styles.cardRow}>
            {user && (
                <>
                    <Card className={styles.card}>
                        <CardHeader title="Info" />
                        <CardContent>
                            <ConsumerInfo user={user} />
                        </CardContent>
                    </Card>
                    {/* <Card className={styles.card}>
                        <CardHeader title="Consumer Monitors" />
                        <CardContent>
                            <ConsumerDevices
                                devices={user?.protected.devices ?? {}}
                            />
                        </CardContent>
                    </Card> */}
                </>
            )}
        </div>
    );
};
